function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
  Merge objects, like Object.assign, but never changes the objects
  (a copy is always made if the object needs to be changed).

  This function always returns an object. The first parameter MUST be a
  non-array object.
 */
function deepMerge(state, mergeObject) {
  if (state && _typeof(state) !== 'object' || Array.isArray(state)) {
    throw new TypeError("invalid parameter type: '".concat(Array.isArray(state) ? 'array' : _typeof(state), "'"));
  }
  if (_typeof(mergeObject) !== 'object' || mergeObject === null) {
    // @ts-expect-error
    return state || {};
  }
  var mergeKeys = Object.keys(mergeObject);
  if (mergeKeys.length <= 0) {
    // @ts-expect-error
    return state || {};
  }
  if (!state) {
    // @ts-expect-error
    return _objectSpread({}, mergeObject);
  }

  // @ts-expect-error
  var returnState = _objectSpread({}, state);
  for (var i = 0; i < mergeKeys.length; i++) {
    var key = mergeKeys[i];
    if (mergeObject[key] === null) {
      returnState[key] = null;
    } else if (!Object.prototype.hasOwnProperty.call(returnState, key) || _typeof(mergeObject[key]) !== 'object' || Array.isArray(mergeObject[key])) {
      returnState[key] = mergeObject[key];
    } else {
      returnState[key] = deepMerge(returnState[key], mergeObject[key]);
    }
  }
  return returnState;
}
export default deepMerge;